import React, { useEffect } from 'react';
import {AiOutlineCheck, AiOutlineClose} from 'react-icons/ai'

function About({c, members, description}) {
  

  useEffect(() => {
  })
  
  return (
  <div className={c.info}>
    <div className={c.infoCard}>
      <div className={c.ihead}>
        Description
      </div>
      <div className={c.ibody}>
        {description || ""}
        {!description || description.replace(/\s/g, "") == "" ? <span style={{color: 'rgba(0,0,0,0.4)'}}>No description...</span> : false}
      </div>
      {!description && typeof description != 'string' && (
        <div className="loading-white" style={{position: 'absolute', top: 0, left: 0, width: "100%", height: '100%'}}></div>
      )}
    </div>

    <div className={c.infoCard}>
      <div className={c.ihead}>
        Members
      </div>
      <div className={c.members}>
        {members.map((member, index) => {
          return (
          <div key={"room-about-member-"+index} className={c.member}>
            <span>{member.name || ""}</span>
            {member.voted ? 
            <AiOutlineCheck style={{color: 'green'}}></AiOutlineCheck>
            :
            <AiOutlineClose style={{color: 'red'}}></AiOutlineClose>
            }
          </div>
          )
        })}
        {members?.length === 0 && <span style={{color: 'rgba(0,0,0,0.4)'}}>No member yet...</span>}
        {!description && typeof description != 'string' && (
          <div className="loading-white" style={{position: 'absolute', top: 0, left: 0, width: "100%", height: '100%'}}></div>
        )}
      </div>
    </div>
  </div>
  );
}

export default About;